/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { CircularProgress, makeStyles } from "@material-ui/core";
import { connect } from "react-redux";
import { loadAppConf, loadOrganizationData, loadUser } from "src/redux/actions";
import { apiLoadAppConf, apiLoadProfile, apiUpdateProfile } from "src/api";
import safeLogger from "src/services/safeLogger";
import { useNavigate } from "react-router-dom";
import { getUserActivePermissions } from "./utils";
import _ from "lodash";
import {
  apiAddToSystemStatusChoices,
  apiGetOrganizationRedux,
  apiLoadOrganizationKits,
} from "src/api/endpoints";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  spinner: {
    position: "absolute",
    top: "48%",
    left: "48%",
  },
}));

function mapDispatchToProps(dispatch) {
  return {
    loadUser: (userData) => dispatch(loadUser(userData)),
    loadAppConf: (confData) => dispatch(loadAppConf(confData)),
    loadOrganizationData: (confData) =>
      dispatch(loadOrganizationData(confData)),
  };
}

const mapStateToProps = (state) => {
  return {
    authToken: state.authToken || localStorage.getItem("mbiAuth"),
    userObject: state.userObject,
    appConf: state.appConf,
    organization: state.organization,
  };
};

const ConnectedAppInitiator = (props) => {
  const {
    loadAppConf,
    userObject,
    loadUser,
    organization,
    loadOrganizationData,
  } = props;
  const [user, setUser] = useState();
  const classes = useStyles();
  const navigate = useNavigate();
  const appConf = useSelector((state) => state.appConf);
  const [loadingAppConf, setLoadingAppConf] = useState(false);
  const [loadedOrganizationKits, setLoadedOrganizationKits] = useState(false);

  useEffect(() => {
    safeLogger("NODE_ENV: ", process.env.API_URL);
    safeLogger("REACT_APP_ENV: ", process.env.REACT_APP_ENV);

    if (!userObject && !user) {
      apiLoadProfile(null, (data, status) => {
        let isUpdated = 0;
        if (status === 200) {
          let userData = data;
          if (!userData.hasOwnProperty("settings") || !userData.settings) {
            userData.settings = {
              general: {
                defaultLang: "en_GB",
                defaultTheme: "light",
              },
            };
            isUpdated++;
          }
          if (!userData.settings.hasOwnProperty("general")) {
            userData.settings.general = {
              defaultLang: "en_GB",
              defaultTheme: "light",
            };
          }
          if (!userData.settings.general.hasOwnProperty("defaultLang")) {
            userData.settings.general.defaultLang = "en_GB";
            isUpdated++;
          }
          if (!userData.settings.general.hasOwnProperty("defaultTheme")) {
            userData.settings.general.defaultTheme = "light";
            isUpdated++;
          }
          if (!userData.settings.hasOwnProperty("filtersets")) {
            userData.settings.filtersets = {};
            isUpdated++;
          }
          if (!userData.settings.hasOwnProperty("general")) {
            userData.settings.general = {};
            userData.settings.general.defaultLang = "en_GB";
            isUpdated++;
          } else {
            if (!userData.settings.general.hasOwnProperty("defaultLang")) {
              userData.settings.general.defaultLang = "en_GB";
              isUpdated++;
            }
          }
          const creatable_projects = [
            "acnv",
            "duo",
            "exome_bam",
            "exome_fastq",
            "exome_vcf",
            "trio",
            "acnv_bam",
            "fusion",
            "filtersets",
            "version",
          ];

          if (!userData.settings.hasOwnProperty("report")) {
            userData.settings.report = {
              ...userData.settings.report,
            };
          }
          for (const report of creatable_projects) {
            if (
              !userData.settings.report[report] &&
              report !== "filtersets" &&
              report !== "version"
            ) {
              const reportObj = userData.settings.report[report] ?? {};
              if (!reportObj.charts) {
                reportObj.charts = {};
                isUpdated++;
              }
              if (!reportObj.defaultDetailsTab) {
                reportObj.defaultDetailsTab = "main";
                isUpdated++;
              }
              if (!reportObj.defaultMainTab) {
                reportObj.defaultMainTab = "variant_table";
                isUpdated++;
              }
              if (!reportObj.statistics) {
                reportObj.statistics = {};
                isUpdated++;
              }
              userData.settings = {
                ...userData.settings,
                report: {
                  ...userData.settings.report,
                  [report]: reportObj,
                },
              };
            }
          }

          if (userData.settings.report.hasOwnProperty("filtersets")) {
            if (!userData.settings.hasOwnProperty("filtersets")) {
              if (
                userData.settings.report &&
                userData.settings.report.hasOwnProperty("filtersets")
              ) {
                userData.settings.filtersets =
                  userData.settings.report.filtersets;
              } else {
                userData.settings.filtersets = {};
              }

              delete userData.settings.report.filtersets;
              isUpdated++;
            } else {
              const isSame = _.isEqual(
                userData.settings.report.filtersets,
                userData.settings.filtersets,
              );
              if (!isSame || userData.settings.report.filtersets) {
                userData.settings.filtersets =
                  userData.settings.report.filtersets;
                delete userData.settings.report.filtersets;
                isUpdated++;
              }
            }

            for (const report of Object.keys(userData.settings.report)) {
              if (
                !creatable_projects.includes(report) &&
                report !== "version"
              ) {
                delete userData.settings.report[report];
                isUpdated++;
              }
            }
            if (!userData.settings.hasOwnProperty("version")) {
              userData.settings.version = 2;
              isUpdated++;
            }
          }

          if (isUpdated > 0) {
            apiUpdateProfile(
              { settings: userData.settings },
              (data, status) => {
                if (status === 200) {
                  window.location.reload();
                }
              },
            );
          }
          // selecting active organization
          if (userData.organizations.length > 1) {
            if (!localStorage.getItem("activeOrganizationId")) {
              navigate("/select-organization");
            } else {
              for (let i = 0; i < userData.organizations.length; i++) {
                if (
                  userData.organizations[i].id ===
                  parseInt(localStorage.getItem("activeOrganizationId"))
                ) {
                  userData["activeOrganization"] = userData.organizations[i];
                  break;
                }
              }
            }

            // get the user data with active organization and set active permissions
            if (userData["activeOrganization"]) {
              apiLoadProfile(
                userData["activeOrganization"].id,
                (data, status) => {
                  if (status === 200) {
                    data["activeOrganization"] = userData["activeOrganization"];
                    data["activePermissions"] = getUserActivePermissions(data);
                    userData = data;
                    loadUser(userData);
                  }
                },
              );
            } else {
              localStorage.removeItem("activeOrganizationId");
            }
          } else {
            if (!localStorage.getItem("activeOrganizationId")) {
              localStorage.setItem(
                "activeOrganizationId",
                userData.organizations[0].id,
              );
            }
            userData["activeOrganization"] = userData.organizations[0];
            userData["activePermissions"] = getUserActivePermissions(userData);
          }
          if (
            userData["activeOrganization"] &&
            userData["activeOrganization"].name
          ) {
            window.pagesense.push([
              "identifyUser",
              `${userData.username}-${userData["activeOrganization"].name}`,
            ]);
          }

          const setUserOnChange = (value) => {
            setUser(value);
            loadUser(value);
          };

          setUserOnChange(userData);

          window.hsConversationsSettings = {
            loadImmediately: false,
            identificationEmail: data.email,
          };
        }
      });
    }
    if (
      userObject &&
      userObject["activeOrganization"] &&
      _.isEmpty(organization)
    ) {
      apiGetOrganizationRedux(
        userObject["activeOrganization"].id,
        (data, status) => {
          if (status === 200) {
            if (!data.status_choices.length)
              apiAddToSystemStatusChoices(data.id);
            loadOrganizationData(data);
          }
        },
      );
    }
  }, [appConf, userObject]);

  useEffect(() => {
    if (
      userObject &&
      userObject["activeOrganization"] &&
      appConf &&
      appConf.entities &&
      appConf.entities.kits &&
      !loadedOrganizationKits
    ) {
      setLoadedOrganizationKits(true);
      apiLoadOrganizationKits(
        userObject["activeOrganization"].id,
        (kits, status) => {
          if (status === 200) {
            if (!appConf.entities.kits) appConf.entities.kits = { ...kits };
            else appConf.entities.kits = { ...kits, ...appConf.entities.kits };
            loadAppConf({ ...appConf });
          }
        },
      );
    }
  }, [appConf, userObject, loadingAppConf]);

  useEffect(() => {
    if (_.isEmpty(appConf) && !_.isEmpty(userObject) && !loadingAppConf) {
      setLoadingAppConf(true);
      apiLoadAppConf((data, status) => {
        if (status === 200) {
          // TODO get language from backend
          data["lang"] =
            userObject?.settings?.general &&
            userObject?.settings?.general["defaultLang"]
              ? userObject?.settings?.general["defaultLang"]
              : "en_GB";
          safeLogger(data);
          if (
            userObject &&
            userObject["activeOrganization"] &&
            data &&
            data.entities &&
            data.entities.kits &&
            !loadedOrganizationKits
          ) {
            setLoadedOrganizationKits(true);
            apiLoadOrganizationKits(
              userObject["activeOrganization"].id,
              (kits, status) => {
                if (status === 200) {
                  if (!data.entities.kits) data.entities.kits = { ...kits };
                  else data.entities.kits = { ...kits, ...data.entities.kits };
                  loadAppConf({ ...data });
                }
              },
            );
          } else {
            loadAppConf({ ...data });
          }
        } else if (status === 401) {
          localStorage.removeItem("mbiAuth");
          localStorage.removeItem("activeOrganizationId");
          navigate("/signin");
        }
        setLoadingAppConf(false);
      });
    }
  }, [userObject]);

  return <CircularProgress className={classes.spinner} />;
};

const AppInitiator = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConnectedAppInitiator);

export default AppInitiator;
